import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const stats = [
  { value: 10, suffix: " ans", label: "d'expérience terrain" },
  { value: 48, suffix: "h", label: "pour recevoir votre devis" },
  { value: 100, suffix: "%", label: "particuliers accompagnés en direct" },
];

export const Stats = () => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    const counters = el.querySelectorAll(".stat-value");
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      counters.forEach((counter) => {
        const target = Number(counter.dataset.value);
        const obj = { val: 0 };
        gsap.to(obj, {
          val: target,
          duration: 1.2,
          ease: "power2.out",
          scrollTrigger: { trigger: el, start: "top 75%", once: true },
          onUpdate: () => { counter.textContent = Math.round(obj.val); },
        });
      });
    });
    return () => mm.revert();
  }, []);

  return (
    <section ref={ref} className="bg-brand-deep py-16 lg:py-24 noise-overlay relative" data-testid="stats-section">
      <div className="max-w-site mx-auto px-5 lg:px-6 grid grid-cols-3 gap-6 lg:gap-8 text-center">
        {stats.map((s) => (
          <div key={s.label}>
            <p className="font-heading font-bold text-5xl lg:text-7xl text-metal tnum leading-none">
              <span className="stat-value" data-value={s.value}>{s.value}</span>
              {s.suffix}
            </p>
            <p className="mt-3 text-sm lg:text-[15px] font-medium text-white/75">{s.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
